module.exports = __webpack_public_path__ + "static/media/embed_type_video.7f09c7c5.svg";